export default __webpack_public_path__ + "static/media/carte-bancaire.4698a481.png";